import React from "react";
import { Formik } from "formik";
import HOC from "../../components/HOC";
import CustomerComponents from "../../components/screen/customer/Customer";
import {
  initialValues,
  validationSchema,
} from "../../components/context/CostumerProviderFormik";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";

const Customer = () => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnChange
    >
      <div className="">
        <PageTemplate
          header="Pelanggan"
          mainComponent={<CustomerComponents />}
          checkOwner={true}
        />
      </div>
    </Formik>
  );
};

export default HOC(Customer);
